import auth from '@auth'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const idTokenData = auth.getToken()

export default {
  namespaced: true,
  state: {
    status: false,
    error: null,
    message: '',
    loading: false,
    isLoggedIn: !!idTokenData,
  },
  getters,
  mutations,
  actions,
}
